import PolicyLayout from './PolicyLayout';
import { SITE_NAME, SITE_DOMAIN } from '../constants/site';
import { CONTACT } from '../constants/contact';

export default function TermsOfService() {
  return (
    <PolicyLayout title="Terms Of Service">
      <h2>Agreement</h2>
      <p>
        By using {SITE_NAME} ({SITE_DOMAIN}), operated by {CONTACT.company}, you agree to these terms.
      </p>
      <h2>Support services</h2>
      <p>
        We provide technical guidance for Dragon NaturallySpeaking products. Results depend on your
        hardware, operating system, license status, and the information you provide.
      </p>
      <h2>Products & pricing</h2>
      <p>
        Product listings and prices may change without notice until an order is confirmed by our team.
        Compatibility checks are recommended before purchase.
      </p>
      <h2>Contact</h2>
      <p>
        {CONTACT.email} · {CONTACT.address}
      </p>
    </PolicyLayout>
  );
}
